
import React, { useEffect } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Euro } from 'lucide-react';
import { useListingForm } from '@/context/ListingFormContext';

const ListingDeliverySection = () => {
  const { formData, handleInputChange, isAuthenticated } = useListingForm();
  
  // Check if the selected category is a service category (no condition/delivery required)
  const isServiceCategory = ['8', '9', '10'].includes(formData.category);
  
  // Force pickup_only for unauthenticated users
  useEffect(() => {
    if (!isAuthenticated && formData.deliveryOption === 'shipping_and_pickup') {
      handleInputChange('deliveryOption', 'pickup_only');
    }
  }, [isAuthenticated, formData.deliveryOption, handleInputChange]);
  
  // If it's a service category, don't show the delivery section
  if (isServiceCategory) {
    return null;
  }

  return (
    <>
      <div className="mb-4">
        <Label htmlFor="deliveryOption" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Opsionet e Dorëzimit
        </Label>
        <Select 
          value={formData.deliveryOption} 
          onValueChange={(value) => handleInputChange('deliveryOption', value)}
        >
          <SelectTrigger id="deliveryOption" className="w-full mt-1">
            <SelectValue placeholder="Zgjidhni opsionin e dorëzimit" />
          </SelectTrigger>
          <SelectContent>
            {/* Only show shipping_and_pickup for authenticated users */}
            {isAuthenticated && (
              <SelectItem value="shipping_and_pickup">Dërgimi dhe Tërheqja</SelectItem>
            )}
            <SelectItem value="pickup_only">Vetëm Tërheqje</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      {formData.deliveryOption === 'shipping_and_pickup' && (
        <div className="mb-4">
          <Label htmlFor="shippingCost" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Kostoja e Transportit (€)
          </Label>
          <div className="relative mt-1">
            <Input
              type="number"
              id="shippingCost"
              value={formData.shippingCost}
              onChange={(e) => handleInputChange('shippingCost', e.target.value)}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 dark:bg-gray-800 dark:border-gray-700 dark:text-white pr-10"
              placeholder="Kostoja e transportit në Euro"
              min="0"
              step="0.5"
            />
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-500">
              <Euro size={18} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ListingDeliverySection;
